import { PureComponent } from 'react';

import { MessageAudio } from '../messageAudio';

import fileFetch from './utils/fileFetch';

type PropsT = {
  recordingURL: string;
  date: number;
  conversation: any;
};

export default class MessagePhone extends PureComponent<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  render() {
    const { recordingURL, ...otherProps } = this.props;

    if (!recordingURL) {
      return null;
    }

    const download = fileFetch(recordingURL, true);

    return (
      <MessageAudio
        {...otherProps}
        title="Call recording"
        onDownload={() => {
          if (typeof download === 'function') {
            download();
          }
        }}
        soundfile={{
          src: fileFetch(recordingURL),
          type: 'audio/mp3',
        }}
      />
    );
  }
}
